// make top bar sticky
const navbar = document.getElementById('jsTop');

if (navbar) {
	window.addEventListener('scroll', () => {  
		if (window.pageYOffset >= 30) {
		  navbar.classList.add('sticky');
		} else {
		  navbar.classList.remove('sticky');
		}
		
	  });
}